import type { Folder } from '../../../../util/Types/Folder';

export const findRootFolderOf = (
  tree: Folder[],
  targetId: string,
): Folder | null => {
  const visit = (folder: Folder, root: Folder): Folder | null => {
    if (folder.id === targetId) return root;
    for (const sub of folder.folders ?? []) {
      const hit = visit(sub, root);
      if (hit) return hit;
    }
    return null;
  };
  for (const root of tree) {
    const hit = visit(root, root);
    if (hit) return hit;
  }
  return null;
};
